import { Config } from 'app/shared/services/config';
import { Section, SelectorIdentifier } from '../../models';
import { REGEX_CONFIG } from 'app/shared/utils/regex-utils';
import { CommonSectionIds } from '../common.models';
import { DataDeliveryFieldId } from '../common.models';
import { field } from '../../core/field-schema';
import { required, maxLength, pattern } from '../../core/validator-builders';
import { SampleRateElement } from '../../../models/location-card.model';
import { TritonMonitorConfiguration } from '../triton/models';
import { InitialLocationCardState } from './model';

/**
 * Triton Data Delivery Configuration Section
 */
export const dataDelivery = (state: InitialLocationCardState): Section => {
    const config = state.monitorConfiguration as TritonMonitorConfiguration;
    const isEditMode = !!config;

    return {
        info: {
            id: CommonSectionIds.DataDelivery,
            title: 'ADD_EDIT.ADD_EDIT_DATA_DELIVERY',
            displayTitle: true,
            expandable: true,
            expanded: false,
        },
        rows: [
            // IP Address Row
            {
                info: {
                    id: 'ip-address-row',
                    panelClass: 'custom-50p',
                },
                items: [
                    field.text(DataDeliveryFieldId.PrismDeliveryIPAddress, 'prismdeliveryipaddress', {
                        label: 'ADD_EDIT.IP_ADDRESS',
                        placeholder: 'ADD_EDIT.IP_ADDRESS',
                        value: isEditMode ? config.prismdeliveryipaddress : Config.urls.tritonDataDeliveryIPAdress,
                        panelClass: 'full-width',
                        validators: [
                            required({
                                message: 'HOME.MAP.MARKER_LOCATION_DETAIL.TRITON_REQUIRED_ERRORS_TXT',
                            }),
                            maxLength({
                                value: 100,
                                message: 'HOME.MAP.MARKER_LOCATION_DETAIL.TRITON_REQUIRED_ERRORS_TXT',
                            }),
                            pattern({
                                value: REGEX_CONFIG.ipaddressPattern,
                                message: 'HOME.MAP.MARKER_LOCATION_DETAIL.IP_DNS_ERROR',
                            }),
                        ],
                    }),
                ],
            },
            // Delivery Rates Row
            {
                info: {
                    id: 'delivery-rates-row',
                    panelClass: 'custom-50p',
                },
                items: [
                    field.select<SampleRateElement, number>(DataDeliveryFieldId.PrismDeliveryNormal, 'prismdeliverynormal', {
                        label: 'ADD_EDIT.INPUT_PLACEHOLDER_NORMAL_RATE',
                        placeholder: 'ADD_EDIT.INPUT_PLACEHOLDER_NORMAL_RATE',
                        valueMapper: (option) => option.value,
                        displayMapper: (option) => option.text,
                        panelClass: 'custom-width',
                        value: isEditMode ? config.prismdeliverynormal : 0,
                        validators: [
                            required({
                                message: 'HOME.MAP.MARKER_LOCATION_DETAIL.TRITON_REQUIRED_ERRORS_TXT',
                            }),
                        ],
                        optionsSelector: SelectorIdentifier.DataDeliveryNormalRate,
                    }),
                    field.select<SampleRateElement, number>(DataDeliveryFieldId.PrismDeliveryFast, 'prismdeliveryfast', {
                        label: 'ADD_EDIT.INPUT_PLACEHOLDER_FAST_RATE',
                        placeholder: 'ADD_EDIT.INPUT_PLACEHOLDER_FAST_RATE',
                        panelClass: 'custom-width',
                        value: isEditMode ? config.prismdeliveryfast : 0,
                        valueMapper: (option) => option.value,
                        displayMapper: (option) => option.text,
                        validators: [
                            required({
                                message: 'HOME.MAP.MARKER_LOCATION_DETAIL.TRITON_REQUIRED_ERRORS_TXT',
                            }),
                        ],
                        optionsSelector: SelectorIdentifier.DataDeliveryNormalRate,
                    }),
                ],
            },
        ],
    };
};
